import styles from '@/styles/components/Button.module.scss';
import { motion } from 'motion/react';

export default function Button({ children, ...props }) {
  return (
    <motion.button
      className={styles.customButton}
      {...props}
      whileHover={{
        scale: 1.1,
        transition: { duration: 0.3, type: 'spring', bounce: 0.5, stiffness: 400, damping: 10 },
      }}
      whileTap={{
        scale: 0.95,
        transition: { duration: 0.2 },
      }}
    >
      {children}
    </motion.button>
  );
}
